import { Injectable, signal } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Products } from '@app/_models';
import { environment } from '@environments/environment';
import { CustomHttpUrlEncodingCodec } from '@app/_helpers';
import * as _ from 'lodash'
import { TranslateService } from '@ngx-translate/core';


@Injectable({
    providedIn: 'root'
})
export class HomepageService {
    constructor(private http: HttpClient, private translate: TranslateService,) {
    }

    private mainCategoriesSignal = signal(null);

    public set mainCategories(mainCategories) {
        this.mainCategoriesSignal.set(mainCategories);
    }

    public get mainCategories() {
        return this.mainCategoriesSignal.asReadonly();
    }

    getMainCategory(category) {
        if (!category) return;
        if (category.mainCategory) {
            return _.find(this.mainCategories(), ['_id', category.mainCategory._id]);
        } else {
            return _.find(this.mainCategories(), ['_id', category._id]);
        }
    }


    public categoriesSubject$: BehaviorSubject<any> = new BehaviorSubject(null);
    readonly categories$: Observable<any[]> = this.categoriesSubject$.asObservable();

    get categories() {
        return this.categoriesSubject$.value;
    }

    getHomePage(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/homepage`);
    }

    load() {
        this.getHomePage().subscribe();
    }

    getPages(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/homepage/pages`);
    }

    getMainCategories(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/categories/main-categories?lang=${this.translate.currentLang || "en"}`).pipe(tap(results => {
            this.categoriesSubject$.next(results.categories);
            this.mainCategories = results.categories;
        }));
    }
    getSearchResult(params): Observable<any> {

        let filterParams: HttpParams = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec()
        });
        if (params) {
            _.forEach(params, (value, key) => {
                filterParams = filterParams.append(key, value)
            });
        }

        return this.http.get<any>(`${environment.apiUrl}/homepage/search`, { params: filterParams });
    }

    getAdvancedSearchResult(params): Observable<any> {
        let query = _.cloneDeep(params);
        if (!query.sort) query.sort = 'popular';

        let filterParams: HttpParams = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec()
        });
        if (query) {
            _.forEach(query, (value, key) => {
                filterParams = filterParams.append(key, value)
            });
        }

        return this.http.get<any>(`${environment.apiUrl}/homepage/advanced-search`, { params: filterParams });
    }

    getLayout(layoutId?) {
        let queryParams = `?lang=${this.translate.currentLang || "en"}`;
        if (layoutId) {
            queryParams += `&layoutId=${layoutId}`
        }

        return this.http.get<any>(`${environment.apiUrl}/homepage/layout` + queryParams);
    }

    sendEmail(params) {
        return this.http.post<any[]>(`${environment.apiUrl}/homepage/contact-us`, params);
    }
}
